import script from "./ResearchPane.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResearchPane.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
